import { render, staticRenderFns } from "./TransactionsView.vue?vue&type=template&id=767ddc0f&scoped=true"
import script from "./TransactionsView.vue?vue&type=script&lang=js"
export * from "./TransactionsView.vue?vue&type=script&lang=js"
import style0 from "./TransactionsView.vue?vue&type=style&index=0&id=767ddc0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767ddc0f",
  null
  
)

export default component.exports